module.exports = __webpack_public_path__ + "static/assets/e9eacddad0b88babde1b02b01ba745c0.svg";